// src/components/StarRatingInput.js
import React from 'react';

const StarRatingInput = ({ rating, setRating, disabled }) => {
  const handleClick = (starNumber) => {
    if (disabled) return;
    // If the clicked star is already the current rating, clear the rating (set to null).
    if (rating === starNumber) {
      setRating(null);
    } else {
      setRating(starNumber);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      {Array.from({ length: 5 }, (_, i) => {
        const starNumber = i + 1;
        return (
          <span
            key={i}
            onClick={() => handleClick(starNumber)}
            style={{
              fontSize: '1.5em',
              cursor: disabled ? 'default' : 'pointer',
              color: starNumber <= rating ? '#FFD700' : '#DDD',
              marginRight: '4px'
            }}
          >
            {starNumber <= rating ? '★' : '☆'}
          </span>
        );
      })}
    </div>
  );
};

export default StarRatingInput;
